(function () {
  function cleanup(details) {
    details.classList.remove('pw-acc__row--closing');
    details.removeAttribute('open');
  }

  function initAccordion(acc) {
    // Wire each accordion once. A misauthored row (missing summary/content-wrap) must not throw
    // mid-forEach and abort wiring for later rows, and shopify:section:load must not double-bind
    // the click handler (mirrors the pwWired guard in powerlete-mega-menu.js).
    if (acc.dataset.pwWired) return;
    acc.dataset.pwWired = 'true';

    var scrollEnabled = acc.dataset.scroll !== 'false';

    acc.querySelectorAll('.pw-acc__row').forEach(function (details) {
      var summary = details.querySelector('.pw-acc__summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        if (details.open) {
          // Closing: prevent default, animate 0fr, then remove [open]
          e.preventDefault();
          details.classList.add('pw-acc__row--closing');
          var wrap = details.querySelector('.pw-acc__content-wrap');
          if (!wrap) { cleanup(details); return; }
          var fired = false;

          var timeout = setTimeout(function () {
            if (!fired) { cleanup(details); }
          }, 400);

          wrap.addEventListener('transitionend', function handler() {
            fired = true;
            clearTimeout(timeout);
            wrap.removeEventListener('transitionend', handler);
            cleanup(details);
          });
        } else {
          // Opening: browser adds [open]; after transition, optionally scroll into view
          if (scrollEnabled) {
            var wrap = details.querySelector('.pw-acc__content-wrap');
            if (!wrap) return;
            wrap.addEventListener('transitionend', function handler() {
              wrap.removeEventListener('transitionend', handler);
              wrap.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
            });
          }
        }
      });
    });
  }

  document.querySelectorAll('.pw-acc').forEach(initAccordion);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.pw-acc').forEach(initAccordion);
  });
})();
